export const validateFlsegdSchema = json => {
    return true;
};
